<template>
  <div>
    <el-radio-group
      v-model="type"
      class="ml-4"
    >
      <el-radio
        label="time-based"
        size="large"
      >
        Time-based Retention
      </el-radio>
      <el-radio
        label="months-paid"
        size="large"
      >
        Months Paid Rentention
      </el-radio>
    </el-radio-group>

    <time-based-rentention
      v-if="type === 'time-based'"
      :is-monthly="false"
    />
    <month-based-retention
      v-else
      :is-monthly="false"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, defineAsyncComponent } from 'vue';

import util from '@/Utils/util';

const MonthBasedRetention = defineAsyncComponent(() => import('./Statistics/MonthBasedRetention.vue') as any);

const TimeBasedRentention = defineAsyncComponent(() => import('./Statistics/TimeBasedRentention.vue') as any);

const type = ref('time-based');

util.moveToTop();
</script>
